import React from "react";

export default function LineIcon(props) {
  return (
    <img
      src={"/assets/images/line.png"}
      alt="same"
      width="15"
      {...props}
    />
  );
}
